import React, { Component } from 'react';
import './styles.scss';
import DatePicker from './../../../../components/FormElements/DatePicker/DatePicker';

class EditWorkingHours extends Component {
  constructor(props) {
    super(props);
    this.onDateChange = this.onDateChange.bind(this);
  }

  state = {
    date: null
  };

  onDateChange(date) {
    date = date.target.value;
    this.setState(() => ({
      date
    }));
  }

  render() {
    return (
      <React.Fragment>
        <div className="d-flex flex-row">
          <div className="p-2">
            <DatePicker
              marge={true}
              name="date"
              onChange={this.state.onDateChange}
              value={this.state.date}
              className="date-picker-input"
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default EditWorkingHours;
